module.exports = __webpack_public_path__ + "img/logo.ab92fe21.png";